import { render } from "./CreateUserGuideDialog.vue?vue&type=template&id=780bef26"
import script from "./CreateUserGuideDialog.vue?vue&type=script&lang=js"
export * from "./CreateUserGuideDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__